// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UqITv","col":"styles_col__ULixr"};